import React, { useContext } from 'react';

import type { DateTimeOptions } from '@swf/sports/components/FormattedDateTime/FormattedDateTime';

export interface DisplayConfigContextValue {
  dateTimeOptions: DateTimeOptions | undefined;
}

export const DisplayContext = React.createContext<DisplayConfigContextValue>({
  dateTimeOptions: undefined
});

const DisplayConfigProvider: React.FC<
  React.PropsWithChildren<{
    dateTimeOptions?: DateTimeOptions;
  }>
> = ({ children, ...props }) => (
  <DisplayContext.Provider value={{ dateTimeOptions: props.dateTimeOptions }}>
    {children}
  </DisplayContext.Provider>
);

export const useDisplayConfig = () => useContext(DisplayContext);

export default DisplayConfigProvider;
